import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Lotdequatre = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.84 104.84">
  <G fill={color}>
    <Polygon points="9.69 18.58 4.16 18.58 4.16 .25 .8 .25 .8 21.64 9.69 21.64 9.69 18.58"/>
    <Path d="M15.99,21.88c1.65,0,2.91-.46,3.79-1.39.88-.93,1.31-2.26,1.31-3.99V5.38c0-1.73-.44-3.06-1.31-3.99-.88-.93-2.14-1.39-3.79-1.39s-2.91.46-3.79,1.39c-.88.93-1.31,2.26-1.31,3.99v11.12c0,1.73.44,3.06,1.31,3.99.88.93,2.14,1.39,3.79,1.39ZM14.24,5.17c0-.77.16-1.32.47-1.63s.74-.47,1.27-.47.95.16,1.27.47.47.86.47,1.63v11.55c0,.77-.16,1.32-.47,1.64s-.74.47-1.27.47-.95-.16-1.27-.47-.47-.86-.47-1.64V5.17Z"/>
    <Polygon points="25.8 21.64 29.16 21.64 29.16 3.3 32.67 3.3 32.67 .25 22.28 .25 22.28 3.3 25.8 3.3 25.8 21.64"/>
    <Path d="M15.39,37.87c.46-.5.69-1.23.69-2.19v-6.01c0-.96-.23-1.69-.69-2.19s-1.16-.75-2.1-.75h-2.96v11.89h2.96c.94,0,1.64-.25,2.1-.75ZM12.21,36.92v-8.49h1.05c.29,0,.53.08.7.25s.25.47.25.9v6.18c0,.43-.08.73-.25.9-.17.17-.4.25-.7.25h-1.05Z"/>
    <Polygon points="22.36 28.43 22.36 26.73 17.27 26.73 17.27 38.62 22.36 38.62 22.36 36.92 19.13 36.92 19.13 33.44 21.7 33.44 21.7 31.74 19.13 31.74 19.13 28.43 22.36 28.43"/>
    <Path d="M28.25,84.8v-41.76h-10.59L0,84.8v8.83h18.72v11.21h9.54v-11.21h4.59v-8.83h-4.59ZM18.72,84.8h-9.8l9.8-23.22v23.22Z"/>
  </G>
</Svg>
);
};

export default Lotdequatre;
